import {
  GoalOverviewRoadmapViewOptions,
  TimelineTimeframes,
} from '@griply/types';
import Typography from '@mui/material/Typography';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TopBarBase } from 'shared/components/connected/top-bar-base';
import { Option, SliderButtons } from 'shared/components/ui/slider-buttons';
import { TimeframeNavigationButtons } from 'shared/components/ui/timeframe-navigation-buttons';

import { AddGoalButton } from '../add-goal-button';
import { ExtraOptionsMenu } from '../extra-options-menu';
import { GoalsFilterButton } from '../goals-filter-button';
import { TimelineAddButton } from '../timeline-add-button';
import * as Styled from './page-top-bar.style';

export type PageTopBarProps = {
  view: GoalOverviewRoadmapViewOptions;
  title: string;
  showTimeframeControls: boolean;

  timeframe: TimelineTimeframes;
  onTimeframe: (timeframe: TimelineTimeframes) => void;

  onPrev: () => void;
  onToday: () => void;
  onNext: () => void;
};

export const PageTopBar: React.FC<PageTopBarProps> = ({
  view,
  title,
  showTimeframeControls,

  timeframe,
  onTimeframe,

  onPrev,
  onToday,
  onNext,
}) => {
  const { t } = useTranslation();

  const isTimeline = view === GoalOverviewRoadmapViewOptions.Timeline;

  const timeframeOptions = useMemo<Option<TimelineTimeframes>[][]>(
    () => [
      [
        {
          label: t('general.labels.timeframes.month.short'),
          value: TimelineTimeframes.Month,
        },
        {
          label: t('general.labels.timeframes.quarter.short'),
          value: TimelineTimeframes.Quarter,
        },
        {
          label: t('general.labels.timeframes.year.short'),
          value: TimelineTimeframes.Year,
        },
        {
          label: t('general.labels.timeframes.five-years.short'),
          value: TimelineTimeframes.FiveYears,
        },
      ],
    ],
    [t],
  );

  return (
    <TopBarBase hideBorder>
      <Styled.Container>
        <Styled.Title>
          <Typography variant="h5" component="h1">
            {title}
          </Typography>
        </Styled.Title>

        <Styled.CenterInteractions>
          {showTimeframeControls && (
            <>
              <SliderButtons
                optionGroups={timeframeOptions}
                onOption={onTimeframe}
                value={timeframe}
                preventDrag
              />

              <TimeframeNavigationButtons
                onPrev={onPrev}
                onToday={onToday}
                onNext={onNext}
              />
            </>
          )}
        </Styled.CenterInteractions>

        <Styled.Interactions>
          <GoalsFilterButton view={view} />
          <ExtraOptionsMenu view={view} />
          {isTimeline ? <TimelineAddButton /> : <AddGoalButton />}
        </Styled.Interactions>
      </Styled.Container>
    </TopBarBase>
  );
};
